import { Controller } from '@hotwired/stimulus'

export default class NavigationController extends Controller {
  static targets = [
    'page',
    'item'
  ]

  static values = {
    pages: { type: Array, default: [] }
  }

  modifierChanged ({ detail: { id, isValid } }) {
    this.updatePageById(id, { isValid })
  }

  goToPage ({ params: { id } }) {
    const page = this.findPageById(id)

    if (page.isCompleted) {
      this.updatePageById(page.id, { isCompleted: false, isCurrent: true })
      this.updateNextPagesByPosition(page.position, { isCompleted: false, isCurrent: false })
    }
  }

  nextPage ({ params: { id } }) {
    const page = this.findPageById(id)

    if (page.isValid) {
      this.updatePageById(id, { isCompleted: true, isCurrent: false })
      const nextPosition = page.position + 1
      const nextPage = this.findPageByPosition(nextPosition)
      if (nextPage !== undefined) {
        this.updatePageById(nextPage.id, { isCurrent: true })
      }
    }
  }

  pageTargetConnected (target) {
    this.pagesValue.forEach(page => {
      this.dispatch('pageUpdated', { target, detail: page })
    })
  }

  pagesValueChanged () {
    this.pagesValue.forEach(page => this.dispatchPageUpdated(page))
  }

  dispatchPageUpdated (page) {
    this.itemTargets.forEach(itemTarget => {
      this.dispatch('pageUpdated', { target: itemTarget, detail: page })
    })

    this.pageTargets.forEach(pageTarget => {
      this.dispatch('pageUpdated', { target: pageTarget, detail: page })
    })
  }

  findPageById (id) {
    const page = this.pagesValue.find(page => page.id === id)

    if (page === undefined) {
      throw new TypeError(`Not found page ${id}`)
    }

    return page
  }

  findPageByPosition (position) {
    return this.pagesValue.find(page => page.position === position)
  }

  findPageIndexById (id) {
    const index = this.pagesValue.findIndex(page => page.id === id)

    if (index === undefined) {
      throw new TypeError(`Not found page ${id}`)
    }

    return index
  }

  updatePageById (id, params) {
    const pageList = Array.from(this.pagesValue)
    let page = this.findPageById(id)
    const index = this.findPageIndexById(id)

    page = { ...page, ...params }
    pageList[index] = page

    this.pagesValue = Array.from(pageList)
  }

  updateNextPagesByPosition (currentPosition, params) {
    const [{ position: lastPosition }] = this.pagesValue.reverse()
    const pageList = Array.from(this.pagesValue)

    this.pagesValue = Array.from(
      pageList.map((page) => {
        if (page.position > currentPosition && page.position <= lastPosition) {
          return { ...page, ...params }
        }

        return page
      })
    )
  }

  updateAllPages (params) {
    let pageList = Array.from(this.pagesValue)
    pageList = pageList.map(page => ({ ...page, ...params }))

    this.pagesValue = Array.from(pageList)
  }
}
